export function i18n(i18nCode){
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    const i18nList = userInfo.i18nList;
    var i18n = i18nList.find(item=>item.code == i18nCode);
    if(i18nCode == "nav_label_sys_manage"){
        console.log("nav_label_sys_manage="+ typeof i18n.name+"   "+i18n.name)
    }
    return (i18n == null || i18n == undefined) ? i18nCode : (i18n.name == "" ? i18nCode : i18n.name );;
}